// extracted by mini-css-extract-plugin
export default {"registrationQuestion":"FillHoles_registrationQuestion__8p8pC","fillTheHoles":"FillHoles_fillTheHoles__5bBjz","icons":"FillHoles_icons__FI0qM"};